import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React from "react";
import classesPropType from "@xo-union/classes-prop-type";
import { useButtonClasses } from "./ThemeContext.js";
const ANIMATION_DURATION = 250;
export const useAnimationProps = () => {
  const [clicked, setClicked] = React.useState(false);
  const timerRef = React.useRef();
  const onClick = React.useCallback(() => {
    setClicked(true);
    clearTimeout(timerRef.current);
    timerRef.current = _setTimeout(() => {
      setClicked(false);
    }, ANIMATION_DURATION);
  }, []);
  React.useEffect(() => () => {
    clearTimeout(timerRef.current);
  }, []);
  return {
    clicked,
    onClick
  };
};
export const AnimatedElement = _ref => {
  let {
    classes: classesProp
  } = _ref;
  const classes = useButtonClasses(classesProp);
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classes['animated-element']
  });
};
process.env.NODE_ENV !== "production" ? AnimatedElement.propTypes = {
  /**
   * Class dependencies
   */
  classes: classesPropType(['animated-element'])
} : void 0;